import { useMemo } from 'react';
import { HeatmapFilterGrouping } from 'libs/end-to-end/src/heatmap-analysis';
import { CSVRow } from 'apps/sigma2-ui/src/lib/utils/csv-export';

/**
 * Custom hook that generates CSV data from heatmap filter grouping
 * @param {HeatmapFilterGrouping | null} filteredGrouping - The filtered grouping data containing metrics and values
 * @returns {CSVRow[]} CSV formatted string containing rows to be used in the DownloadButton component
 *
 * @example
 * const filteredData = useHeatmapExport(groupingData);
 * // Returns: "Focus Area 1 - Metric 1,Focus Area 2 - Metric 2\nGroup1,value1,value2\nGroup2,value3,value4"
 */
export const useHeatmapExport = (
  filteredGrouping: HeatmapFilterGrouping | null,
): CSVRow[] => {
  const dataForCsvComponent = useMemo(() => {
    if (!filteredGrouping) return [];

    const values = filteredGrouping.filterData.values;
    const metrics = filteredGrouping.filterData.metrics;

    // Transform values into array of objects with metric names as keys
    const dataRows = Object.entries(values).map(([group, rowValues]) => {
      const row: CSVRow = { Group: group };
      metrics.forEach((metric, index) => {
        const key = `${metric.focusArea} - ${metric.metric}`;
        const value = rowValues[index];
        row[key] = value ? `${(value * 100).toFixed(2)}%` : '';
      });
      return row;
    });

    return dataRows;
  }, [filteredGrouping]);

  return dataForCsvComponent;
};
